import * as React from 'react';

export function SvgAtlassian(props: any) {
  return (
    <svg viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M17.6587 16.7836L9.72008 0.906309C9.56381 0.562509 9.40754 0.5 9.22001 0.5C9.06374 0.5 8.87621 0.562509 8.68868 0.875054C7.56352 2.65656 7.06345 4.71936 7.06345 6.87592C7.06345 9.87635 8.59492 12.6893 10.8452 17.2212C11.0953 17.7212 11.2828 17.815 11.7204 17.815H17.2212C17.6275 17.815 17.8463 17.6587 17.8463 17.3462C17.8463 17.1899 17.815 17.0961 17.6587 16.7836ZM6.12581 9.28252C5.50072 8.34488 5.31319 8.28237 5.15692 8.28237C5.00065 8.28237 4.90689 8.34488 4.6256 8.90746L0.656273 16.8461C0.531255 17.0961 0.5 17.1899 0.5 17.3149C0.5 17.565 0.718782 17.815 1.1876 17.815H6.78216C7.15721 17.815 7.4385 17.5025 7.59477 16.9086C7.7823 16.1585 7.84481 15.5022 7.84481 14.7208C7.84481 12.533 6.87592 10.4077 6.12581 9.28252Z"
        fill="currentColor"
      />
    </svg>
  );
}
